import { commitMutation } from 'react-relay';
import environment from '../Environment';
import { showMutationError } from './errorReport';

function doCommit(mutation, variables, onSuccess, onError) {
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      if (errors) {
        showMutationError(errors);
        if (onError) {
          return onError(errors);
        }
      }
      if (onSuccess) {
        onSuccess(response, errors);
      }
      return null;
    },
    onError: (error) => {
      if (onError) onError(error);
    },
  });
}

export function doCommitPromise(
  mutation,
  variables,
  onSuccess = null,
  onError = null,
  updater = null,
  uploadables = null,
  preValidator = null,
) {
  return new Promise((resolve, reject) => {
    if (preValidator) {
      if (!preValidator()) {
        reject();
        if (onError) onError();
        return;
      }
    }
    const config = {
      mutation,
      variables: typeof variables === 'function' ? variables() : variables,
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
          if (onError) return onError(errors);
          return null;
        }
        resolve();
        if (onSuccess) {
          onSuccess(response, errors);
        }
        return null;
      },
      onError: (error) => {
        if (!onError) {
          showMutationError(error);
        }
        reject(error);
        if (onError) onError(error);
      },
    };
    if (updater) config.updater = updater;
    if (uploadables) config.uploadables = uploadables;

    commitMutation(environment, config);
  });
}

export const graceErrChecked = callback => (response, errors) => {
  if (!errors || errors.length === 0) {
    callback && callback();
  }
};

export default doCommit;
